import { Toaster, TooltipProvider } from '@planuze/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './components/theme-provider.js';
import { AdminLocaleProvider } from './content/locale-provider.js';
import { queryClient, setSessionExpiredHandler } from './query-client.js';
import { router } from './router.js';
import { useStaffSessionStore } from './stores/staff-session-store.js';
import './styles.css';

/* Interceptor global de 401 (ADR-0699): sessão expirada no meio do uso limpa a metadata
   e redireciona ao login de forma graciosa, em vez de "erro genérico" até renavegar.
   Registrado aqui pois precisa do router (query-client não importa router — evita ciclo). */
setSessionExpiredHandler(() => {
  useStaffSessionStore.getState().clear();
  router.navigate({ to: '/login' }).catch(() => undefined);
});

const rootEl = document.getElementById('root');
if (rootEl !== null) {
  createRoot(rootEl).render(
    <StrictMode>
      <ThemeProvider>
        <AdminLocaleProvider>
          <QueryClientProvider client={queryClient}>
            {/* delayDuration curto (~200ms): tooltips de ajuda dos campos abrem quase
              imediatamente no hover/foco sem virar ruído em passagens rápidas do mouse. */}
            <TooltipProvider delayDuration={200}>
              <RouterProvider router={router} />
            </TooltipProvider>
            <Toaster richColors position="top-right" />
          </QueryClientProvider>
        </AdminLocaleProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}
